import type { Locale } from './locales';
import { es } from './locales/es';

export type TranslationValues = Readonly<Record<string, string | number>>;

const CATALOGS: Partial<Record<Locale, Readonly<Record<string, string>>>> = { 'es-ES': es };

/** The English key in `locale`, falling back to the key itself; `{name}` placeholders filled in. */
export function translate(locale: Locale, key: string, values?: TranslationValues): string {
  const template = CATALOGS[locale]?.[key] ?? key;
  if (!values) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) => {
    const value = values[name];
    return value === undefined ? match : String(value);
  });
}
